export default __webpack_public_path__ + "static/media/phone_green.46ce49b9.svg";